import { ProgressBar, PulseLoader } from '@sparemin/blockhead';
import Modal from 'components/Modal';

export interface ShareExportingBodyProps {
  progress?: number;
  mode?: 'progress' | 'loader';
  className?: string;
}

const ShareExportingBody: React.FC<ShareExportingBodyProps> = ({
  mode,
  progress,
  className,
}) => {
  return (
    <Modal.Body className={className}>
      {mode === 'progress' ? (
        <ProgressBar
          value={progress}
          isIndeterminate={progress === undefined}
        />
      ) : (
        <PulseLoader />
      )}
    </Modal.Body>
  );
};

export default ShareExportingBody;
